import { ItemCard } from './ItemCard';

interface OvertimeRule {
    overtime_rule_id: number;
    name: string;
}

interface Zone {
    zone_id: number;
    name: string;
}

interface ScheduleDesviationRule {
    schedule_desviation_rule_id: number;
    name: string;
}

interface CombinationItem {
    id?: number;
    name: string;
    description?: string;
    overtime_rules?: OvertimeRule[];
    zones?: Zone[];
    schedule_desviation_rules?: ScheduleDesviationRule[];
}

interface ListCardsProps {
    item: CombinationItem[];
    onDelete: ((item: CombinationItem) => void) | null;
    onEdit: ((item: CombinationItem) => void) | null;
}

export const ListCards = ({ item, onDelete, onEdit }: ListCardsProps) => {
    return (
        <div>
            {item.map((item, index) => (
                <ItemCard key={index} item={item} onDelete={onDelete} onEdit={onEdit} />
            ))}
        </div>
    );
};
